import { IMultiSelectOptions } from "@starrez/starryui";
import { IEmailDataModel } from "..";
import { ParticipantSelectType } from "../../steps/ParticipantDetails/ParticipantSelector";

export enum CommunityParticipantType {
    Concern,
    Contribution,
    Incident,
}

export interface IParticipantEmailDataModel extends IEmailDataModel {

    ParticipantEntryIDs: number[];
    ParticipantSelectItems: IMultiSelectOptions[];

    CommunityParticipantType?: CommunityParticipantType;
    ParticipantSelectorOptions?: ParticipantSelectType;
}
